// Centralized query keys for React Query

export type ExperimentViewsFilters = {
  offset?: number;
  limit?: number;
  name?: string;
  state?: string[];
  dates?: string[];
};

function normalizeFilters(filters: ExperimentViewsFilters): string {
  return JSON.stringify(
    Object.entries(filters)
      .filter(([, v]) => v !== undefined && v !== null && v !== '')
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([k, v]) => [k, Array.isArray(v) ? [...v].sort() : v]),
  );
}

export const experimentKeys = {
  // Planner related queries
  planner: {
    experiment: (experimentName: string) =>
      ['planner', 'experiment', experimentName] as const,
    regionalExperimentChildren: (experimentName: string, countryCode: string) =>
      [
        'planner',
        'regionalExperimentChildren',
        experimentName,
        countryCode,
      ] as const,
    adaptiveExperiment: (experimentName: string) =>
      ['planner', 'adaptiveExperiment', experimentName] as const,
    experimentTags: (experimentName: string) =>
      ['planner', 'tags', experimentName] as const,
    experimentEvents: (experimentName: string) =>
      ['planner', 'events', experimentName] as const,
    experimentAvailability: (domain: string, restrictBy: string) =>
      ['planner', 'availability', domain, restrictBy] as const,
    experimentViews: (filters: ExperimentViewsFilters) =>
      ['planner', 'experimentViews', normalizeFilters(filters)] as const,
    scorecard: (experimentName: string) =>
      ['planner', 'scorecard', experimentName] as const,
    metricScorecards: (experimentName: string) =>
      ['planner', 'metricScorecard', experimentName] as const,
    metricScorecard: (experimentName: string, metricId: string) =>
      ['planner', 'metricScorecard', experimentName, metricId] as const,
    metricQuery: (
      experimentName: string,
      metricId: string,
      dimension = 'overall',
    ) =>
      ['planner', 'metricQuery', experimentName, metricId, dimension] as const,
  },
} as const;
